/**
 * Rishora Premium Product Card - Auto Preview Logic
 */
(function() {
  if (window.RishoraCardPreviewInitialized) return;
  window.RishoraCardPreviewInitialized = true;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  
  // Track shown products in session storage
  const sessionKey = 'rishora_previewed_products';
  let previewedProducts = [];
  try {
    const stored = sessionStorage.getItem(sessionKey);
    if (stored) previewedProducts = JSON.parse(stored);
  } catch(e) {}

  let isScrolling = false;
  let scrollTimeout;

  window.addEventListener('scroll', () => {
    isScrolling = true;
    clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(() => {
      isScrolling = false;
    }, 150);
  }, { passive: true });

  const io = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const card = entry.target;
        const productId = card.getAttribute('data-product-id');
        
        // Skip if already previewed in this session
        if (previewedProducts.includes(productId)) {
          io.unobserve(card);
          return;
        }

        // Wait for scrolling to stop
        const attemptPreview = () => {
          if (isScrolling) {
            setTimeout(attemptPreview, 100);
            return;
          }
          
          // Organic stagger between 200ms and 1100ms
          const stagger = Math.floor(Math.random() * 900) + 200;
          
          setTimeout(() => {
            // Re-verify intersection before animating
            const rect = card.getBoundingClientRect();
            const isVisible = rect.top < window.innerHeight && rect.bottom >= 0;
            if (isVisible && !card.classList.contains('is-previewing')) {
              card.classList.add('is-previewing');
              
              // Record in session storage
              previewedProducts.push(productId);
              try {
                sessionStorage.setItem(sessionKey, JSON.stringify(previewedProducts));
              } catch(e) {}
              
              io.unobserve(card);
            }
          }, 2500 + stagger); // 2.5s base delay + stagger
        };
        
        attemptPreview();
      }
    });
  }, { threshold: 0.5 }); // Trigger when 50% visible

  function initializeCards() {
    if (window.RishoraAutoPreviewEnabled === false) return;
    const cards = document.querySelectorAll('.card-wrapper[data-preview-auto="true"]:not(.rishora-initialized)');
    
    cards.forEach(card => {
      card.classList.add('rishora-initialized');
      io.observe(card);
      
      // Desktop hover interaction to clear the auto-preview state
      card.addEventListener('mouseleave', () => {
        card.classList.remove('is-previewing');
      });
    });
  }

  // Initialize on load
  document.addEventListener('DOMContentLoaded', initializeCards);
  initializeCards(); // In case DOM is already loaded

  // Watch for newly added cards (Infinite scroll, filters)
  const mo = new MutationObserver((mutations) => {
    let shouldInit = false;
    for (const mutation of mutations) {
      if (mutation.addedNodes.length) {
        shouldInit = true;
        break;
      }
    }
    if (shouldInit) initializeCards();
  });
  
  mo.observe(document.body, { childList: true, subtree: true });
})();
